import styled from 'styled-components';
import { rgba } from 'polished';

interface ContainerProps {
  managed: boolean;
}

export const Container = styled.div<ContainerProps>`
  .manage-box {
    background: ${(props) => rgba(props.theme.$white, 0.12)};
  }

  .manage-main,
  .manage-caret {
    box-shadow: none;
    font-size: 14px;
    line-height: 1;

    &:hover {
      background: ${(props) => rgba(props.theme.$white, 0.08)};
    }
  }

  .manage-caret {
    border-left: 1px solid ${(props) => rgba(props.theme.$white, 0.25)};
    border-radius: 0;
    padding-left: 6px;
    padding-right: 6px;

    i {
      font-size: 18px;
    }
  }

  .manage-star {
    font-size: 18px;
    color: ${(props) => (props.managed ? props.theme.$yellow : props.theme.$white)};
    position: relative;
    top: -1px;
  }

  .manage-count {
    font-size: 12px;
    line-height: 1;
    padding: 3px 6px;

    i {
      font-size: 13px;
      margin-right: 2px;
    }
  }

  .manage-menu {
    min-width: 220px;

    .dropdown-item {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
`;
